import _ from 'lodash'

import Vue from 'vue'

import { store } from '_/vuex/store'

const InputTag = Vue.component(
  'InputTag',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    advancedSearchName: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: Number,
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    label: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    refreshFields: {
      type: Number,
    },
  },

  /**
   * Define components
   *
   * @type  {Object}
   */
  components: {
    InputTag,
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    /**
     * advancedSearch model getter
     *
     * @return  {object}
     */
    advancedSearch() {
      const getterName = `${this.advancedSearchName}/${this.advancedSearchName}`

      return this.$store.getters[getterName]
    },

    /**
     * Fetches the value for the 'json_key' field
     *
     * @return  {string}
     */
    valueJsonKey() {
      const path = `payload.filter.${this.filterGroup}.${this.name}.json_key`

      if (_.has(this.advancedSearch, path)) {
        return this.advancedSearch.payload.filter[this.filterGroup][this.name].json_key
      }

      return null
    },

    /**
     * Fetches the value for the 'json_value' field
     *
     * @return  {string}
     */
    valueJsonValue() {
      const path = `payload.filter.${this.filterGroup}.${this.name}.json_value`

      if (_.has(this.advancedSearch, path)) {
        return this.advancedSearch.payload.filter[this.filterGroup][this.name].json_value
      }

      return null
    },

    /**
     * Fetches the value for the 'contains' field
     *
     * @return  {string}
     */
    valueContains() {
      const path = `payload.filter.${this.filterGroup}.${this.name}.contains`

      if (_.has(this.advancedSearch, path)) {
        return this.advancedSearch.payload.filter[this.filterGroup][this.name].contains
      }

      return null
    },

    filterGroup() {
      return this.isSystem ? 'system' : 'fields'
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Define a method that runs on change event
     *
     * @param   {string}  options.name
     * @param   {string}  options.value
     * @return  {void}
     */
    onChange({ name, value }) {
      store.dispatch(`${this.advancedSearchName}/updateFilterValue`, {
        fieldName: name,
        value,
      })
    },
  },

  /**
   * Set the beforeDestroy hook
   *
   * @return  {void}
   */
  beforeDestroy() {
    store.dispatch(`${this.advancedSearchName}/removeFilter`, {
      fieldName: `filter.${this.filterGroup}.${this.name}`,
    })
  },
}